import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';

import { cnHeader } from '../Header@mobile';
import { HeaderProps } from '../Header.interface';
import { serviceLogoSrc, serviceNameLogoSrc } from '../Header.constants';
const { scripts } = require('../scripts');

const { toolsHeader } = scripts;

export interface WithNoAuthMobile {
    noAuth?: boolean;
}

const getHeaderNoAuthHTML = (): string => (toolsHeader.mobile({
    ctx: {
        formAction: '//yandex.ru/search/',
        serviceLogoUrl: '/',
        serviceNameLogoUrl: '/',
        serviceLogoSrc,
        serviceNameLogoSrc,
        tools: true,
    },
}));

export const withNoAuthMobile = withBemMod<WithNoAuthMobile, HeaderProps>(
    cnHeader(),
    { noAuth: true },
    (Header): FC<HeaderProps & WithNoAuthMobile> => (
        (props): ReactElement => {
            const replacer = (
                <div
                    className={cnHeader()}
                    dangerouslySetInnerHTML={{
                        __html: getHeaderNoAuthHTML(),
                    }}
                />
            );

            return (
                <Header
                    {...props}
                    replacer={replacer}
                />
            );
        }),
);
